import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 18l14 -4","key":"svg-0"}],["path",{"d":"M5 14l14 -4l-14 -4","key":"svg-1"}]]

/**
 * IconMathEqualGreater
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbWF0aC1lcXVhbC1ncmVhdGVyIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik01IDE4bDE0IC00IiAvPgogIDxwYXRoIGQ9Ik01IDE0bDE0IC00bC0xNCAtNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/math-equal-greater
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconMathEqualGreater = createReactComponent('outline', 'math-equal-greater', 'MathEqualGreater', __iconNode);

export default IconMathEqualGreater;